import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TlkButtonComponent } from '@itero/ui-toolkit-angular/button';
import { TlkModalWindowModule, TlkModalWindowRef, TLK_MODAL_WINDOW_DATA } from '@itero/ui-toolkit-angular/modal-window';
import { TlkRadioButtonComponent, TlkRadioGroupDirective } from '@itero/ui-toolkit-angular/radio-button';
import { WarningIconComponent } from '@itero/ui-toolkit-angular/icons';

import { SaveContinueScannerIconComponent } from '@shared/components/save-continue-icons/save-continue-scanner-icon.component';
import { SaveContinueLabBrokerIconComponent } from '@shared/components/save-continue-icons/save-continue-lab-broker-icon.component';

export type DentiraUnavailableSelection = 'tryAgainLater' | 'completeOnLabBroker';

export type DentiraUnavailableResult = DentiraUnavailableSelection | null;

export interface LabBrokerUnavailableDialogData {
	name: string;
}

@Component({
	selector: 'rx-lab-broker-unavailable-dialog',
	templateUrl: './lab-broker-unavailable-dialog.component.html',
	styleUrls: ['./lab-broker-unavailable-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		FormsModule,
		TranslateModule,
		TlkModalWindowModule,
		TlkButtonComponent,
		TlkRadioButtonComponent,
		TlkRadioGroupDirective,
		WarningIconComponent,
		SaveContinueScannerIconComponent,
		SaveContinueLabBrokerIconComponent
	]
})
export class LabBrokerUnavailableDialogComponent {
	selectedOption: DentiraUnavailableSelection | null = null;

	constructor(
		public readonly dialogRef: TlkModalWindowRef<DentiraUnavailableResult, LabBrokerUnavailableDialogComponent>,
		@Inject(TLK_MODAL_WINDOW_DATA) public readonly data: LabBrokerUnavailableDialogData
	) {}

	get isConfirmDisabled(): boolean {
		return this.selectedOption === null;
	}

	selectTryAgainLater(): void {
		this.selectedOption = 'tryAgainLater';
	}

	selectCompleteOnLabBroker(): void {
		this.selectedOption = 'completeOnLabBroker';
	}

	cancel(): void {
		this.dialogRef.close(null);
	}

	confirm(): void {
		if (this.selectedOption === null) {
			return;
		}

		this.dialogRef.close(this.selectedOption);
	}
}
